<script>
import { ref } from 'vue'

export default {
  setup(props, { slots }) {
    const active    = ref(false)
    const toggle    = (payload) => {
      active.value = payload
    }

    return () => slots.default({
      active: active.value,
      toggle
    })
  }
}
</script>